import { withInstall } from '../utils/index';
import './index.less';
import Map from './index.vue';

export const TlbsJUEMap = withInstall(Map);
export default TlbsJUEMap;
